import { render, staticRenderFns } from "./revisePassword.vue?vue&type=template&id=276529b4&scoped=true"
import script from "./revisePassword.vue?vue&type=script&lang=js"
export * from "./revisePassword.vue?vue&type=script&lang=js"
import style0 from "./revisePassword.vue?vue&type=style&index=0&id=276529b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276529b4",
  null
  
)

export default component.exports